import { useWizard } from '@restworld/utils-common';

import { useWorkerApplicationCxt } from '../../worker-application-wizard.context';

export const useSkippedStep = () => {
  const { skippedSteps } = useWorkerApplicationCxt();
  const { activeStep } = useWizard();
  return skippedSteps.includes(activeStep);
};
